var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageDucEditorResetDesktop = function SvgImageDucEditorResetDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.107.41a.6.6 0 0 1 .484.696L20.6 6.6h-6.296a.6.6 0 0 1 0-1.2h4.668a9.7 9.7 0 0 0-7.738-3.8C5.9 1.6 1.6 5.822 1.6 11s4.3 9.4 9.635 9.4c2.149 0 4.459-.825 6.225-2.243 1.762-1.414 2.94-3.38 2.94-5.657a.6.6 0 1 1 1.2 0c0 2.723-1.413 5.007-3.388 6.593-1.971 1.582-4.544 2.507-6.977 2.507C5.265 21.6.4 16.867.4 11S5.264.4 11.235.4c3.461 0 6.547 1.589 8.531 4.066L20.41.894a.6.6 0 0 1 .697-.484Z",
    fill: "#fff"
  })));
};
export default SvgImageDucEditorResetDesktop;